import type { ToolHandler } from '@norkin/chat-openai';

export const toolHandlers: Record<string, ToolHandler> = {
  get_weather: async args => ({
    tempC: 21,
    location: typeof (args as any)?.location === 'string' ? (args as any).location : 'Unknown',
    args,
  }),
};
